import { takeLatest, call, put } from 'redux-saga/effects';
import { getAllLabs, uploadContent } from './api';
import {
  fetchAllLabsSuccess,
  fetchAllLabsFail,
  fetchUploadContentSubmissionSuccess,
  fetchUploadContentSubmissionFail,
} from './actions';
import commonActionTypes from './action-types';

function* getAllLabsSaga({ payload }) {
  try {
    const response = yield call(getAllLabs, payload);
    yield put(fetchAllLabsSuccess(response.data));
  } catch (error) {
    yield put(fetchAllLabsFail());
  }
}

function* fetchUploadContentSubmissionSaga({ payload }) {
  try {
    const { orderId, files, callbackAction } = payload;

    const uploadedContent = new FormData();
    uploadedContent.append('OperationKey', orderId);
    files.forEach(file => {
      uploadedContent.append('Files', file);
    });

    const response = yield call(uploadContent, { data: uploadedContent });
    callbackAction();
    yield put(fetchUploadContentSubmissionSuccess(response.data));
  } catch (error) {
    yield put(fetchUploadContentSubmissionFail(error));
  }
}

function* commonSagas() {
  yield takeLatest(commonActionTypes.FETCH_ALL_LABS, getAllLabsSaga);
  yield takeLatest(
    commonActionTypes.FETCH_UPLOAD_CONTENT_SUBMISSION,
    fetchUploadContentSubmissionSaga,
  );
}

export default commonSagas;
